'use client';

import { useEffect } from 'react';

import { ErrorPage } from '@/views/errorPage';

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    window.reportError(error);
  }, [error]);

  return (
    <ErrorPage
      errorMessage={`Your request couldn’t be completed right now. You can try again or contact Eon Support if the problem keeps happening.`}
      title={'Something went wrong'}
    />
  );
}
